module.exports = __webpack_public_path__ + "images/emoji/1234.e9557414e7c4932b3081.png";